import DashboardConfig from './DashboardConfig';

export default DashboardConfig;
export * from './DashboardConfig';
